import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import MobileStickyBar from './components/MobileStickyBar';
import Home from './components/pages/Home';
import About from './components/pages/About';
import Services from './components/pages/Services';
import Doctors from './components/pages/Doctors';
import Branches from './components/pages/Branches';
import BranchDetail from './components/pages/BranchDetail';
import Gallery from './components/pages/Gallery';
import Contact from './components/pages/Contact';
import Appointment from './components/pages/Appointment';
import FloatingActions from './components/FloatingActions';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div 
          className="flex flex-col min-h-screen text-gray-800 bg-white"
          style={{ fontFamily: 'emoji' }}
        >
          <Navbar />
          <main className="flex-grow pb-16 lg:pb-0"> {/* Padding bottom for mobile sticky bar */}
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/doctors" element={<Doctors />} />
              <Route path="/branches" element={<Branches />} />
              <Route path="/branches/:slug" element={<BranchDetail />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/appointment" element={<Appointment />} />
            </Routes>
          </main>
          <Footer />
          <MobileStickyBar />
          <FloatingActions />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
